var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-style",class:[_vm.size, _vm.type],style:(_vm.style),on:{"click":function($event){$event.stopPropagation();return _vm.ClickBtn.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }